import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import sagas from '../sagas';
import reducers from '../reducers';

import {
  middleware as routesMiddleware,
  enhancer as routesEnhancer,
} from '../routes';

import analyticsMiddleware from './middleware/analytics';

const isNotProduction = process.env.NODE_ENV !== 'production';

const sagasMiddleware = createSagaMiddleware();

const composeMiddlewares = applyMiddleware(
  routesMiddleware,
  sagasMiddleware,
  analyticsMiddleware,
);

// Use Redux DevTools Extension if available and not in production.
const composeEnhancers =
  (isNotProduction && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default createStore(
  reducers,
  composeEnhancers(routesEnhancer, composeMiddlewares),
);

sagasMiddleware.run(sagas);



// WEBPACK FOOTER //
// ./src/store/index.js